// extracted by mini-css-extract-plugin
module.exports = {"pictureCell":"pictureCell--LpcnC","pickWord":"pickWord--rOGtA","pickWordImg":"pickWordImg--n0nS9","pictureSpeaker":"pictureSpeaker--Tg6ag"};